import { render, staticRenderFns } from "./configuration-sourcing.vue?vue&type=template&id=4b00f588&"
import script from "./js/configuration-sourcing.js?vue&type=script&lang=js&"
export * from "./js/configuration-sourcing.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports